import { Injectable } from '@angular/core';

const TOKEN_KEY = 'AuthToken';
const CUSTOMER_ID = 'XeyeCustomerId';
const MS_ACCESS_TOKEN = 'MaAccessToken';
const MS_USER_DISPLAY_NAME = "MsUserDisplayName";
const MS_USER_EMAIL = "MsUserEmail";
const USER_TYPE = "UserType";

@Injectable()
export class LocalStorageService {

  constructor() { }

  public saveOrUpdateAuthToken(token: string) {
      window.sessionStorage.removeItem(TOKEN_KEY);
      window.sessionStorage.setItem(TOKEN_KEY,  token);
  }

  public getAuthToken(): string {
    return sessionStorage.getItem(TOKEN_KEY);
  }

  public removeAuthToken() {
      window.sessionStorage.removeItem(TOKEN_KEY);
  }

  public saveCustomerId(customerId: string) {
      window.sessionStorage.removeItem(CUSTOMER_ID);
      window.sessionStorage.setItem(CUSTOMER_ID,  customerId);
  }

  public getCustomerId(): string {
    return sessionStorage.getItem(CUSTOMER_ID);
  }

  public removeCustomerId() {
      window.sessionStorage.removeItem(CUSTOMER_ID);
  }

  public saveMSUserDisplayName(displayName: string) {
      window.sessionStorage.removeItem(MS_USER_DISPLAY_NAME);
      window.sessionStorage.setItem(MS_USER_DISPLAY_NAME,  displayName);
  }

  public getMSUserDisplayName(): string {
    return sessionStorage.getItem(MS_USER_DISPLAY_NAME);
  }

  public removeMSUserDisplayName() {
      window.sessionStorage.removeItem(MS_USER_DISPLAY_NAME);
  }

  public saveMSUserEmail(msUserEmail: string) {
      window.sessionStorage.removeItem(MS_USER_EMAIL);
      window.sessionStorage.setItem(MS_USER_EMAIL,  msUserEmail);
  }

  public getMSUserEmail(): string {
    return sessionStorage.getItem(MS_USER_EMAIL);
  }

  public removeMSUserEmail() {
      window.sessionStorage.removeItem(MS_USER_EMAIL);
  }

  public saveMSAccessToken(token: string) {
      window.sessionStorage.removeItem(MS_ACCESS_TOKEN);
      window.sessionStorage.setItem(MS_ACCESS_TOKEN,  token);
  }

  public getMSAccessToken(): string {
    return sessionStorage.getItem(MS_ACCESS_TOKEN);
  }

  public removeMSAccessToken() {
      window.sessionStorage.removeItem(MS_ACCESS_TOKEN);
  }

  public saveUserType(token: string) {
      window.sessionStorage.removeItem(USER_TYPE);
      window.sessionStorage.setItem(USER_TYPE,  token);
  }

  public getUserType(): string {
    return sessionStorage.getItem(USER_TYPE);
  }

  public removeUserType() {
      window.sessionStorage.removeItem(USER_TYPE);
  }


}



// WEBPACK FOOTER //
// ./src/app/common-service/local-storage/local-storage.service.ts